import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Badge } from "@/components/ui/badge";
import { ParameterControl } from "./ParameterControl";

const slug = (g) =>
  g
    .replace(/^\d+\)\s*/, "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");

export const PhaseConfigurator = ({ meta, config, onChange }) => {
  if (!meta) return null;
  const { groups, parameters } = meta;

  return (
    <Accordion
      type="multiple"
      defaultValue={groups}
      className="space-y-3"
      data-testid="phase-configurator"
    >
      {groups.map((group) => {
        const params = parameters.filter((p) => p.group === group);
        return (
          <AccordionItem
            key={group}
            value={group}
            data-testid={`phase-${slug(group)}`}
            className="rounded-xl border border-border bg-card px-4 shadow-[var(--shadow-sm)]"
          >
            <AccordionTrigger className="py-3 hover:no-underline">
              <div className="flex items-center gap-2 text-left">
                <span className="font-semibold tracking-[-0.01em]">{group}</span>
                <Badge variant="secondary" className="text-[10px] md:text-xs font-mono">
                  {params.length}
                </Badge>
              </div>
            </AccordionTrigger>
            <AccordionContent>
              <div className="divide-y divide-border/70">
                {params.map((p) => (
                  <div key={p.key} className="py-2">
                    <ParameterControl
                      param={p}
                      value={config[p.key]}
                      onChange={(v) => onChange(p.key, v)}
                    />
                  </div>
                ))}
              </div>
            </AccordionContent>
          </AccordionItem>
        );
      })}
    </Accordion>
  );
};
